import { Container } from "@mui/system";

import {
    Grid,
    Typography,
    Paper,
    TextField,
    Checkbox,
    Button,
    Divider,
    MenuPaper,
    RadioGroup,
    FormControlLabel,
    Radio,
    Autocomplete,
} from "@mui/material";

import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import ListSubheader from '@mui/material/ListSubheader';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from '@mui/icons-material/Info';
import FormHelperText from '@mui/material/FormHelperText';
import React, { useEffect } from "react";
import globals from "../globals";
import { useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LoadingPage from "../error_page/loadingPage";
import LoadingIcon from "../components/loading";
import { addDays, formatDate, formatToISO } from "../utils";

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const courses =
    [
        {
            name: 'Урок1',
            date: '05.07.2025',
            time: '09:00'
        },
        {
            name: 'Урок2',
            date: '27.06.2025',
            time: '06:00'
        },
        {
            name: 'Урок3',
            date: '20.06.2025',
            time: '12:00'
        },
        {
            name: 'Урок4',
            date: '11.02.2025',
            time: '17:00'
        },
    ]


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const hours = [
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
];

const minutes = [
    "00", "15", "30", "45"
]
const todayDate = new Date();
let days = ['Понеделник', 'Вторник', 'Сряда', 'Четвъртък', 'Петък', 'Събота', 'Неделя', 'Понеделник', 'Вторник', 'Сряда', 'Четвъртък', 'Петък', 'Събота', 'Неделя']
// const startingDay = addDays(todayDate, 3);
const startingDay = todayDate;
days = days.slice(startingDay.getDay() - 1, 7).concat(days.slice(0, startingDay.getDay() - 1));
console.log({ days })

const selectStyles = {
    minWidth: 100,
    backgroundColor: globals.colors.lightPink, // Light pink
    borderRadius: 1,
    "& .MuiOutlinedInput-root": {
        "& fieldset": { border: "none" },
        "&:hover fieldset": { border: "none" },
        "&.Mui-focused fieldset": { border: "none" },
    },
};
const weekDays = { 'monday': 'Понеделник', 'tuesday': 'Вторник', 'wednesday': 'Сряда', 'thursday': 'Четвъртък', 'friday': 'Петък', 'saturday': 'Събота', 'sunday': 'Неделя' };
const weekDaysToEnglish = { 'Понеделник': 'monday', 'Вторник': 'tuesday', 'Сряда': 'wednesday', 'Четвъртък': 'thursday', 'Петък': 'friday', 'Събота': 'saturday', 'Неделя': 'sunday' };
const dayToDayNumber = { 'Понеделник': 0, 'Вторник': 1, 'Сряда': 2, 'Четвъртък': 3, 'Петък': 4, 'Събота': 5, 'Неделя': 6 };

const ZoomPage = ({ adminCreate = false }) => {
    const { id, student_id, meetingId } = useParams();
    const editMode = Boolean(meetingId);
    const isAdminMode = editMode || adminCreate;
    const { token } = useAuth();
    const [loading, setLoading] = React.useState(true);
    const [startHour, setStartHour] = React.useState(0);
    const [startMinute, setStartMinute] = React.useState(0);
    const [endHour, setEndHour] = React.useState("");
    const [totalMinutes, setTotalMinutes] = React.useState(0);
    const [endMinute, setEndMinute] = React.useState("");
    const [day, setDay] = React.useState("");
    const [slots, setSlots] = React.useState({});
    const [duration, setDuration] = React.useState(0);
    const [firstMeeting, setFirstMeeting] = React.useState(false);
    const [title, setTitle] = React.useState("");
    const [loadingSubmit, setLoadingSubmit] = React.useState(false);
    const [startingDate, setStartingDate] = React.useState("");
    const [upcomingMeetings, setUpcomingMeetings] = React.useState([]);
    const [slotsDays, setSlotsDays] = React.useState([]);
    const [slotType, setSlotType] = React.useState("normal");
    const [zoomAccountId, setZoomAccountId] = React.useState("");
    const [showSuccess, setShowSuccess] = React.useState(false);
    const [showError, setShowError] = React.useState(false);

    // Admin mode (editing an existing meeting, or creating a new one as
    // admin): free-form date/time instead of picking from the
    // instructor's available slots.
    const [editInstructorId, setEditInstructorId] = React.useState("");
    const [editInstructorName, setEditInstructorName] = React.useState("");
    const [editInstructorOptions, setEditInstructorOptions] = React.useState([]);
    const [editCourseId, setEditCourseId] = React.useState("");
    const [editCourseOptions, setEditCourseOptions] = React.useState([]);
    const [editStudentId, setEditStudentId] = React.useState("");
    const [editStudentOptions, setEditStudentOptions] = React.useState([]);
    const [editStudentsLoading, setEditStudentsLoading] = React.useState(false);
    const [editMeetingType, setEditMeetingType] = React.useState("normal");
    const [editRecurring, setEditRecurring] = React.useState(false);
    const [editStartDate, setEditStartDate] = React.useState("");
    const [editStartTime, setEditStartTime] = React.useState("");
    const [editStartMinute, setEditStartMinute] = React.useState("00");
    const [editEndDate, setEditEndDate] = React.useState("");
    const [editEndTime, setEditEndTime] = React.useState("");
    const [errorMessage, setErrorMessage] = React.useState("");
    const [editAvailableSlots, setEditAvailableSlots] = React.useState([]);
    const [editSlotsLoading, setEditSlotsLoading] = React.useState(false);
    const [editMeetingDuration, setEditMeetingDuration] = React.useState(0);
    const [createZoomAccountId, setCreateZoomAccountId] = React.useState("");

    const fetchMeetingForEdit = () => {
        if (!editMode || !token) return;
        fetch(`${globals.apiUrl}/admin/zoom-meetings/${meetingId}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => res.json())
            .then((data) => {
                setTitle(data.topic || "");
                setEditCourseId(data.course_id ?? "");
                setEditInstructorId(data.instructor_id ?? "");
                setEditInstructorName(data.instructor || "");
                setEditStudentId(data.student_id ?? "");
                setEditMeetingType(data.type || "normal");
                setEditRecurring(Boolean(data.recurring));

                const pad = (n) => String(n).padStart(2, "0");
                const splitDateTime = (isoString) => {
                    const d = new Date(isoString);
                    return {
                        date: `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`,
                        time: `${pad(d.getHours())}:${pad(d.getMinutes())}`,
                    };
                };
                const start = splitDateTime(data.from_time);
                const end = splitDateTime(data.to_time);
                setEditStartDate(start.date);
                setEditStartTime(start.time);
                setEditStartMinute(start.time.split(':')[1]);
                setEditEndDate(end.date);
                setEditEndTime(end.time);
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (adminCreate) {
            setLoading(false);
            return;
        }
        fetchMeetingForEdit();
    }, [editMode, adminCreate, meetingId, token]);

    const resetCreateForm = () => {
        setTitle("");
        setEditInstructorId("");
        setEditCourseId("");
        setEditStudentId("");
        setEditMeetingType("normal");
        setEditRecurring(false);
        setEditStartDate("");
        setEditStartTime("");
        setEditStartMinute("00");
        setEditEndDate("");
        setEditEndTime("");
        setCreateZoomAccountId("");
    };

    const handleEditCancel = () => {
        setShowSuccess(false);
        setShowError(false);
        setErrorMessage("");
        if (adminCreate) {
            resetCreateForm();
        } else {
            fetchMeetingForEdit();
        }
    };

    useEffect(() => {
        if (!adminCreate || !token) return;
        fetch(`${globals.apiUrl}/admin/instructors`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => res.json())
            .then((data) => setEditInstructorOptions(Array.isArray(data) ? data : []))
            .catch(console.error);
    }, [adminCreate, token]);

    useEffect(() => {
        if (!isAdminMode || !token) return;
        fetch(`${globals.apiUrl}/admin/courses`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => res.json())
            .then((data) => setEditCourseOptions(Array.isArray(data) ? data : []))
            .catch(console.error);
    }, [isAdminMode, token]);

    useEffect(() => {
        if (!isAdminMode || !token || !editCourseId) {
            setEditStudentOptions([]);
            return;
        }
        setEditStudentsLoading(true);
        fetch(`${globals.apiUrl}/admin/courses/${editCourseId}/students`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => res.json())
            .then((data) => setEditStudentOptions(Array.isArray(data) ? data : []))
            .catch(console.error)
            .finally(() => setEditStudentsLoading(false));
    }, [isAdminMode, token, editCourseId]);

    const handleEditInstructorChange = (event, newValue) => {
        setEditInstructorId(newValue ? newValue.id : "");
        setEditCourseId("");
        setEditStudentId("");
    };

    const handleEditCourseChange = (event, newValue) => {
        setEditCourseId(newValue ? newValue.id : "");
        setEditStudentId("");
    };

    const handleEditStudentChange = (event, newValue) => {
        setEditStudentId(newValue ? newValue.id : "");
    };

    useEffect(() => {
        if (!isAdminMode || !token || !editStartDate || !editCourseId) return;
        setEditSlotsLoading(true);
        const url = editMode
            ? `${globals.apiUrl}/admin/zoom-meetings/${meetingId}/slots?date=${editStartDate}&course_id=${editCourseId}`
            : `${globals.apiUrl}/admin/zoom-slots?date=${editStartDate}&course_id=${editCourseId}`;
        fetch(url, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        })
            .then((res) => res.json())
            .then((data) => {
                setEditAvailableSlots(Array.isArray(data?.timeslots) ? data.timeslots : []);
                setEditMeetingDuration(typeof data?.duration === 'number' ? data.duration : 0);
            })
            .catch(console.error)
            .finally(() => setEditSlotsLoading(false));
    }, [isAdminMode, editMode, meetingId, token, editStartDate, editCourseId]);

    const recomputeEditStartAndEnd = (hour, minute) => {
        const h = parseInt(hour, 10);
        const m = parseInt(minute, 10);
        if (Number.isNaN(h) || Number.isNaN(m)) return;
        const pad = (n) => String(n).padStart(2, "0");
        const totalStartMinutes = h * 60 + m;
        const totalEndMinutes = totalStartMinutes + editMeetingDuration;
        setEditStartTime(`${pad(h)}:${pad(m)}`);
        setEditEndDate(editStartDate);
        setEditEndTime(`${pad(Math.floor(totalEndMinutes / 60))}:${pad(totalEndMinutes % 60)}`);
    };

    const handleEditSlotSelect = (slot) => {
        const [slotHour] = slot.start_time.split(':');
        recomputeEditStartAndEnd(slotHour, editStartMinute);
        if (!editMode) setCreateZoomAccountId(slot.zoom_account_id);
    };

    const handleEditMinuteChange = (e) => {
        const raw = e.target.value;
        if (raw === "") {
            setEditStartMinute("");
            return;
        }
        const clamped = Math.max(0, Math.min(59, parseInt(raw, 10)));
        if (Number.isNaN(clamped)) return;
        const minute = String(clamped).padStart(2, "0");
        setEditStartMinute(minute);
        const [currentHour] = (editStartTime || "0:00").split(':');
        recomputeEditStartAndEnd(currentHour, minute);
    };

    useEffect(() => {
        if (!isAdminMode || !editStartTime) return;
        const [currentHour] = editStartTime.split(':');
        recomputeEditStartAndEnd(currentHour, editStartMinute);
        // Only the duration matters here - start hour/minute changes already
        // recompute the end time themselves via the handlers above.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editMeetingDuration]);

    useEffect(() => {
        if (isAdminMode) return;
        fetch(`${globals.apiUrl}/courses/meetings/${id}/slots/${student_id}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }
        )
            .then(response => response.json())
            .then(data => {
                //console.log(data);
                setDuration(data.duration);
                setFirstMeeting(data.first_meeting);
                setUpcomingMeetings(data.upcoming_meetings);
                setSlotType(data.type);

                if (data.starting_date != '') {
                    let slots_days = ['Понеделник', 'Вторник', 'Сряда', 'Четвъртък', 'Петък', 'Събота', 'Неделя'];
                    let slots_starting_day = new Date(data.starting_date);
                    if (data.first_meeting) {
                        slots_starting_day = addDays(slots_starting_day, 3);
                    }
                    setStartingDate(slots_starting_day);
                    slots_days = slots_days.slice(slots_starting_day.getDay() - 1, 7).concat(slots_days.slice(0, slots_starting_day.getDay() - 1));
                    // console.log({ slots_days, slots_starting_day, "data_timeslots": data.timeslots })
                    setSlotsDays(slots_days);
                }
                setSlots(data.timeslots);
                setLoading(false);
            });
    }, [id]);

    const timeToMinutes = (hour, minute) => {
        if (hour === "" || minute === "") return null;
        return parseInt(hour) * 60 + parseInt(minute);
    };

    const handleStartChange = (type) => (event) => {
        if (type === "hour") {
            setStartHour(event.target.value);
            setTotalMinutes(parseInt(event.target.value) * 60 + parseInt(startMinute) + duration);
            const zoom_account_id = slots[weekDaysToEnglish[slotsDays[day]]].timeslots.find(slot => slot.start_time.split(':')[0] === event.target.value).zoom_account_id;
            setZoomAccountId(zoom_account_id);
        }
        if (type === "minute") {
            setStartMinute(event.target.value);
            setTotalMinutes(parseInt(startHour) * 60 + parseInt(event.target.value) + duration);
        }

        // Validate after state update
        // setTimeout(() => {
        //     const start = timeToMinutes(
        //         type === "hour" ? event.target.value : startHour,
        //         type === "minute" ? event.target.value : startMinute
        //     );
        //     const end = timeToMinutes(endHour, endMinute);
        //     if (start !== null && end !== null && start >= end) {
        //         setEndHour("");
        //         setEndMinute("");
        //     }
        // }, 0);
    };

    const handleEndChange = (type) => (event) => {
        if (type === "hour") setEndHour(event.target.value);
        if (type === "minute") setEndMinute(event.target.value);

        setTimeout(() => {
            const start = timeToMinutes(startHour, startMinute);
            const end = timeToMinutes(
                type === "hour" ? event.target.value : endHour,
                type === "minute" ? event.target.value : endMinute
            );
            if (start !== null && end !== null && start >= end) {
                alert("Краят на срещата трябва да е след началото!");
                setEndHour("");
                setEndMinute("");
            }
        }, 0);
    };

    const handleDayChange = (event) => {
        setDay(event.target.value);
    };

    const handleEditSubmit = (e) => {
        e.preventDefault();
        setLoadingSubmit(true);
        setShowSuccess(false);
        setShowError(false);

        if (adminCreate && !editInstructorId) {
            setErrorMessage("Моля, изберете учител.");
            setShowError(true);
            setLoadingSubmit(false);
            return;
        }

        if (!editCourseId || !editStudentId) {
            setErrorMessage("Моля, изберете курс и ученик.");
            setShowError(true);
            setLoadingSubmit(false);
            return;
        }

        if (adminCreate && !createZoomAccountId) {
            setErrorMessage("Моля, изберете свободен час.");
            setShowError(true);
            setLoadingSubmit(false);
            return;
        }

        const combineDateTime = (date, time) => {
            const [hours, minutes] = time.split(':').map(Number);
            const combined = new Date(`${date}T00:00:00`);
            combined.setHours(hours, minutes, 0, 0);
            return combined;
        };
        const startTime = combineDateTime(editStartDate, editStartTime);
        const endTime = combineDateTime(editEndDate, editEndTime);

        if (endTime <= startTime) {
            setErrorMessage("Краят на срещата трябва да е след началото!");
            setShowError(true);
            setLoadingSubmit(false);
            return;
        }

        const url = editMode
            ? `${globals.apiUrl}/admin/zoom-meetings/${meetingId}`
            : `${globals.apiUrl}/admin/zoom-meetings`;
        const body = {
            topic: title,
            start_time: formatToISO(startTime),
            end_time: formatToISO(endTime),
            type: editMeetingType,
            recurring: editRecurring,
            course_id: editCourseId,
            student_id: editStudentId,
        };
        if (!editMode) {
            body.zoom_account_id = createZoomAccountId;
        }

        fetch(url, {
            method: editMode ? 'PUT' : 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(body),
        })
            .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
            .then(({ ok, data }) => {
                if (!ok) {
                    setErrorMessage(data.detail || "Възникна грешка при запазване на срещата!");
                    setShowError(true);
                } else {
                    setShowSuccess(true);
                    if (adminCreate) resetCreateForm();
                }
            })
            .catch((error) => {
                console.error('Error:', error);
                setErrorMessage("Възникна грешка при запазване на срещата!");
                setShowError(true);
            })
            .finally(() => setLoadingSubmit(false));
    };

    const handleSubmit = (e) => {
        if (isAdminMode) {
            handleEditSubmit(e);
            return;
        }
        e.preventDefault();
        setLoadingSubmit(true);
        setShowSuccess(false);
        setShowError(false);
        // const dayOffset = (firstMeeting ? dayToDayNumber[weekDays[day]] : day);
        const dayOffset = day;
        // const start = (firstMeeting ? addDays(new Date(startingDate), 3) : new Date(startingDate));
        const start = new Date(startingDate);
        let startTime = addDays(start, dayOffset);
        startTime.setHours(startHour, startMinute, 0, 0);
        let endTime = addDays(start, dayOffset);
        endTime.setHours(Math.floor(totalMinutes / 60), totalMinutes % 60, 0, 0);
        //console.log(startTime)
        //console.log(endTime)

        // console.log({ slotType })
        const meetingType = firstMeeting ? slotType : "normal";
        fetch(`${globals.apiUrl}/courses/meetings/${id}/zoom/${student_id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({
                zoom_account_id: zoomAccountId,
                topic: title,
                start_time: formatToISO(startTime),
                end_time: formatToISO(endTime),
                type: meetingType,
            }),
        })
            .then(response => response.json())
            .then(data => {
                //console.log(data);
                if (data.detail) {
                    setShowError(true);
                    throw new Error(data.detail);
                }
                else {
                    setShowSuccess(true);
                }
            })
            .catch(error => {
                console.error('Error:', error);
                // setShowError(true);
            })
            .finally(() => {
                setLoadingSubmit(false);
            });
    }
    return (
        <>
            {loading ? <LoadingPage /> : (
                <Container component="form" onSubmit={handleSubmit}>
                    <Typography sx={{ fontSize: 25, color: globals.colors.darkBlue, fontWeight: 'bold' }}>
                        {editMode ? 'Редактирай zoom среща' : adminCreate ? 'Добави Zoom среща' : 'Направете zoom среща'}
                    </Typography>

                    {editMode && editInstructorName && (
                        <Typography sx={{ mt: 1, color: globals.colors.gray }}>
                            Учител: <strong>{editInstructorName}</strong> (не може да се сменя)
                        </Typography>
                    )}

                    <Paper elevation={4} sx={{ mt: 4, borderRadius: 2 }} >
                        <Grid container>
                            <Grid item sm={8} sx={12}>
                                <Grid container direction={'column'} spacing={2}>
                                    {adminCreate && (
                                        <Grid item sx={{ mx: 4 }}>
                                            <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', size: 30 }}>Учител</Typography>
                                            <Autocomplete
                                                options={editInstructorOptions}
                                                getOptionLabel={(option) => `${option.first_name} ${option.last_name}`}
                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                value={editInstructorOptions.find((i) => i.id === editInstructorId) || null}
                                                onChange={handleEditInstructorChange}
                                                renderInput={(params) => (
                                                    <TextField {...params} placeholder="Търси учител..."
                                                        sx={{
                                                            mt: 1, width: '40vw', backgroundColor: globals.colors.lightPink, borderRadius: 1,
                                                            '& .MuiOutlinedInput-root': {
                                                                '& fieldset': { border: 'none' },
                                                                '&:hover fieldset': { border: 'none' },
                                                                '&.Mui-focused fieldset': { border: 'none' },
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    )}

                                    {isAdminMode && (
                                        <>
                                            <Grid item sx={{ mx: 4 }}>
                                                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', size: 30 }}>Курс</Typography>
                                                <Autocomplete
                                                    options={editCourseOptions.filter((c) => c.instructor_id === editInstructorId)}
                                                    disabled={adminCreate && !editInstructorId}
                                                    getOptionLabel={(option) => option.title}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    value={editCourseOptions.find((c) => c.id === editCourseId) || null}
                                                    onChange={handleEditCourseChange}
                                                    renderInput={(params) => (
                                                        <TextField {...params} placeholder={adminCreate && !editInstructorId ? "Първо изберете учител" : "Търси курс..."}
                                                            sx={{
                                                                mt: 1, width: '40vw', backgroundColor: globals.colors.lightPink, borderRadius: 1,
                                                                '& .MuiOutlinedInput-root': {
                                                                    '& fieldset': { border: 'none' },
                                                                    '&:hover fieldset': { border: 'none' },
                                                                    '&.Mui-focused fieldset': { border: 'none' },
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item sx={{ mx: 4 }}>
                                                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', size: 30 }}>Ученик</Typography>
                                                {editStudentsLoading ? <LoadingIcon sx={{ mt: 1 }} /> : (
                                                    <Autocomplete
                                                        options={editStudentOptions}
                                                        getOptionLabel={(option) => `${option.first_name} ${option.last_name}`}
                                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                                        value={editStudentOptions.find((s) => s.id === editStudentId) || null}
                                                        onChange={handleEditStudentChange}
                                                        disabled={!editCourseId}
                                                        renderInput={(params) => (
                                                            <TextField {...params} placeholder={editCourseId ? "Търси ученик..." : "Първо изберете курс"}
                                                                sx={{
                                                                    mt: 1, width: '40vw', backgroundColor: globals.colors.lightPink, borderRadius: 1,
                                                                    '& .MuiOutlinedInput-root': {
                                                                        '& fieldset': { border: 'none' },
                                                                        '&:hover fieldset': { border: 'none' },
                                                                        '&.Mui-focused fieldset': { border: 'none' },
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                )}
                                            </Grid>
                                        </>
                                    )}

                                    <Grid item sx={{ mx: 4 }}>
                                        <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', size: 30, mt: 1 }}>Заглавие на срещата</Typography>
                                        <TextField id="outlined-basic" label="Урок" required variant="outlined"
                                            sx={{
                                                width: '40vw',
                                                mt: 1,
                                                borderRadius: 2,
                                                backgroundColor: globals.colors.lightPink,
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': { border: 'none' },
                                                    '&:hover fieldset': { border: 'none' },
                                                    '&.Mui-focused fieldset': { border: 'none' },
                                                },
                                                '& .MuiInputLabel-root': {
                                                    color: globals.colors.gray, // Label color
                                                },
                                                '& label.Mui-focused': {
                                                    color: globals.colors.darkRed, // Label color when focused
                                                },
                                            }}
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                        />
                                    </Grid >

                                    {isAdminMode && (
                                        <>
                                            <Grid item sx={{ mx: 4 }}>
                                                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', size: 30 }}>Дата на срещата</Typography>
                                                <TextField type="date" required value={editStartDate}
                                                    disabled={adminCreate && !editCourseId}
                                                    onChange={(e) => setEditStartDate(e.target.value)}
                                                    InputLabelProps={{ shrink: true }}
                                                    sx={{ mt: 1, backgroundColor: globals.colors.lightPink, borderRadius: 1 }} />
                                            </Grid>

                                            <Grid item sx={{ mx: 4 }}>
                                                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', size: 30 }}>Свободни часове</Typography>
                                                {editSlotsLoading ? <LoadingIcon sx={{ mt: 1 }} /> : (
                                                    <Grid container spacing={1} sx={{ mt: 0.5 }} alignItems="center">
                                                        {editAvailableSlots.map((slot) => {
                                                            const isSelectedHour = parseInt(editStartTime.split(':')[0], 10) === parseInt(slot.start_time.split(':')[0], 10);
                                                            return (
                                                                <Grid item key={slot.start_time}>
                                                                    <Button
                                                                        variant={isSelectedHour ? 'contained' : 'outlined'}
                                                                        disabled={!slot.available}
                                                                        onClick={() => handleEditSlotSelect(slot)}
                                                                        sx={{
                                                                            textTransform: 'none',
                                                                            backgroundColor: isSelectedHour ? globals.colors.lightRed : undefined,
                                                                            '&:hover': isSelectedHour ? { backgroundColor: globals.colors.darkRed } : undefined,
                                                                        }}
                                                                    >
                                                                        {slot.start_time}
                                                                    </Button>
                                                                </Grid>
                                                            );
                                                        })}
                                                        <Grid item>
                                                            <TextField
                                                                type="number"
                                                                value={editStartMinute}
                                                                onChange={handleEditMinuteChange}
                                                                inputProps={{ min: 0, max: 59 }}
                                                                sx={{ width: 100, backgroundColor: globals.colors.lightPink, borderRadius: 1 }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                )}
                                            </Grid>

                                            <Grid item sx={{ mx: 4 }}>
                                                <Typography sx={{ fontWeight: "bold", color: globals.colors.darkRed }}>
                                                    Край на срещата: {editEndTime} ч.
                                                </Typography>
                                            </Grid>

                                            <Grid item sx={{ mx: 4 }}>
                                                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', size: 30 }}>Тип на срещата</Typography>
                                                <FormControl>
                                                    <RadioGroup row value={editMeetingType} onChange={(e) => setEditMeetingType(e.target.value)}>
                                                        <FormControlLabel value="normal" control={<Radio />} label="Регулярна" />
                                                        <FormControlLabel value="introductory" control={<Radio />} label="Безплатна" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </Grid>

                                            <Grid item sx={{ mx: 4 }}>
                                                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', size: 30 }}>Часова зона</Typography>
                                                <TextField id="outlined-basic" label="Източноевропейско време; EET; UTC+02:00" variant="outlined"
                                                    disabled
                                                    sx={{
                                                        width: '40vw',
                                                        mt: 1,
                                                        borderRadius: 2,
                                                        backgroundColor: globals.colors.lightPink,
                                                        '& .MuiOutlinedInput-root': {
                                                            '& fieldset': { border: 'none' },
                                                            '&:hover fieldset': { border: 'none' },
                                                            '&.Mui-focused fieldset': { border: 'none' },
                                                        },
                                                        '& .MuiInputLabel-root': {
                                                            color: globals.colors.gray, // Label color
                                                        },
                                                    }} />
                                            </Grid >

                                            <Grid item sx={{ mx: 4 }}>
                                                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', size: 30 }}>Записване в облак
                                                    <Checkbox {...label} disabled checked />
                                                </Typography>
                                            </Grid>
                                            <Grid item sx={{ mx: 4 }}>
                                                <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', mb: 2 }}>Повтаряща се среща
                                                    <Checkbox {...label} checked={editRecurring} onChange={(e) => setEditRecurring(e.target.checked)} />
                                                    <Tooltip title="Определя дали срещата да се повтаря.">
                                                        <IconButton>
                                                            <InfoIcon sx={{ color: globals.colors.darkBlue }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Typography>
                                            </Grid>
                                        </>
                                    )}

                                    {!isAdminMode && <><Grid item sx={{ mx: 4 }}>
                                        <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', size: 30 }}>Ден на срещата</Typography>
                                        <FormControl sx={{
                                            minWidth: 600, mt: 1,
                                            '& .MuiOutlinedInput-root': {
                                                backgroundColor: globals.colors.lightPink, // Red background
                                                borderRadius: 1,
                                                '& fieldset': { border: 'none' }, // Remove border
                                                '&:hover fieldset': { border: 'none' },
                                                '&.Mui-focused fieldset': { border: 'none' },
                                            },
                                            '& .MuiSelect-select': {
                                                color: globals.colors.textColor, // Text color inside
                                            },
                                        }} >
                                            <Select
                                                labelId="demo-simple-select-helper-label"
                                                id="demo-simple-select-helper"
                                                value={day}
                                                // label="Age"
                                                onChange={handleDayChange}
                                            >
                                                {/* <MenuItem value="">
                                            <em>Ден</em>
                                        </MenuItem> */}
                                                {
                                                    // firstMeeting ?
                                                    slotsDays.map((day, i) => (slots[weekDaysToEnglish[day]].timeslots.length > 0 && (
                                                        <MenuItem key={i} value={i}>{day} {formatDate(addDays(startingDate, i))}</MenuItem>
                                                    )))
                                                    // Object.keys(slots).map((day) => slots[day].timeslots.length > 0 && (
                                                    //     <MenuItem key={day} value={weekDays[day]}>{weekDays[day]} {formatDate(addDays(new Date(slots[day].date), 2))}</MenuItem>
                                                    // ))
                                                    // : days.map((day, i) => (
                                                    //     <MenuItem key={i} value={i}>{day} {formatDate(addDays(startingDay, i))}</MenuItem>
                                                    // ))
                                                }
                                            </Select>
                                            {/* <FormHelperText>With label + helper text</FormHelperText> */}
                                        </FormControl>
                                    </Grid >


                                    <Grid item sx={{ mx: 4 }}>
                                        <Grid container alignItems="center">
                                            {/* Start Time */}
                                            <Grid item xs={12} sm={4}>
                                                <Typography sx={{ fontWeight: "bold", color: globals.colors.darkBlue }}>
                                                    Начало на срещата
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={6} sm={2}>
                                                <FormControl sx={selectStyles}>
                                                    <Select
                                                        value={startHour}
                                                        onChange={handleStartChange("hour")}
                                                        displayEmpty
                                                    >
                                                        <MenuItem value="">
                                                            <em>Час</em>
                                                        </MenuItem>
                                                        {
                                                            // firstMeeting ?
                                                            slots[weekDaysToEnglish[slotsDays[day]]]?.timeslots?.map((h) => (
                                                                h.available && (
                                                                    <MenuItem key={h} value={h.start_time.split(':')[0]}>{h.start_time.split(':')[0]}</MenuItem>
                                                                )))
                                                            // : hours.map((h) => (
                                                            //     <MenuItem key={h} value={h}>{h}</MenuItem>
                                                            // ))
                                                        }

                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={2}>
                                                <FormControl sx={selectStyles}>
                                                    <Select
                                                        value={startMinute}
                                                        onChange={handleStartChange("minute")}
                                                        displayEmpty
                                                    >
                                                        <MenuItem value="">
                                                            <em>Минута</em>
                                                        </MenuItem>
                                                        {minutes.map((m) => (
                                                            <MenuItem key={m} value={m}>{m}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>


                                            <Grid container alignItems="center" sx={{ mt: 2 }}>
                                                {/* End Time */}
                                                <Grid item xs={12} sm={4}>
                                                    <Typography sx={{ fontWeight: "bold", color: globals.colors.darkBlue }}>
                                                        Край на срещата
                                                    </Typography>
                                                    <Tooltip title="Край на срещата се изчислява по продължителност на курса и началото на срещата.">
                                                        <IconButton>
                                                            <InfoIcon sx={{ color: globals.colors.darkBlue }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Grid>
                                                <Grid item xs={12} sm={2}>
                                                    <FormControl sx={selectStyles}>
                                                        <Select
                                                            disabled
                                                            value={Math.floor(totalMinutes / 60)}
                                                            onChange={handleEndChange("hour")}
                                                            displayEmpty
                                                        >
                                                            <MenuItem value="">
                                                                <em>Час</em>
                                                            </MenuItem>
                                                            {hours.map((h) => (
                                                                <MenuItem key={h} value={h}>{h}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={12} sm={2}>
                                                    <FormControl sx={selectStyles}>
                                                        <Select
                                                            disabled
                                                            value={totalMinutes % 60 === 0 ? "00" : totalMinutes % 60}
                                                            onChange={handleEndChange("minute")}
                                                            displayEmpty
                                                        >
                                                            <MenuItem value="">
                                                                <em>Минута</em>
                                                            </MenuItem>
                                                            {minutes.map((m) => (
                                                                <MenuItem key={m} value={m}>{m}</MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid >


                                    <Grid item sx={{ mx: 4 }}>
                                        <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', size: 30 }}>Часова зона</Typography>
                                        <TextField id="outlined-basic" label="Източноевропейско време; EET; UTC+02:00" variant="outlined"
                                            disabled
                                            sx={{
                                                width: '40vw',
                                                mt: 1,
                                                borderRadius: 2,
                                                backgroundColor: globals.colors.lightPink,
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': { border: 'none' },
                                                    '&:hover fieldset': { border: 'none' },
                                                    '&.Mui-focused fieldset': { border: 'none' },
                                                },
                                                '& .MuiInputLabel-root': {
                                                    color: globals.colors.gray, // Label color
                                                },
                                            }} />
                                    </Grid >

                                    <Grid item sx={{ mx: 4 }}>
                                        <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', size: 30 }}>Записване в облак
                                            <Checkbox {...label} disabled checked />
                                        </Typography>
                                    </Grid>
                                    <Grid item sx={{ mx: 4 }}>
                                        <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold', mb: 2 }}>Повтаряща се среща
                                            <Checkbox {...label} disabled />
                                            <Tooltip title="За повтаряща се среща се обърнете към eAcademiaBg.">
                                                <IconButton>
                                                    <InfoIcon sx={{ color: globals.colors.darkBlue }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Typography>
                                    </Grid></>}
                                </Grid>
                            </Grid>

                            <Grid item sm={4} xs={12}
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'flex-end',
                                }}>
                                <img src={'/zoom.webp'} loading="lazy" decoding="async" style={{ width: 320, height: 300 }} />
                            </Grid>
                        </Grid>
                    </Paper>

                    <Grid container>
                        <Grid item sx={{ justifyContent: 'end', flexDirection: 'column', display: 'flex' }}>
                            <Button variant='contained' type='submit' size='large' sx={{
                                mt: 4, px: 5, backgroundColor: globals.colors.lightRed, textTransform: 'none', '&:hover': {
                                    backgroundColor: globals.colors.darkRed
                                },
                            }}>Запази</Button>
                        </Grid>
                        <Grid item>
                            {loadingSubmit && <LoadingIcon sx={{ ml: 3, mt: 4 }} />}
                        </Grid>
                        <IconButton sx={{ mt: 4, mx: 2, color: globals.colors.gray }} onClick={isAdminMode ? handleEditCancel : undefined}><CancelIcon /></IconButton>

                    </Grid>
                    {showSuccess && <Grid item>
                        <Typography sx={{ color: globals.colors.darkGreen, fontWeight: 'bold' }}>{editMode ? 'Срещата е обновена успешно!' : 'Срещата е създадена успешно!'}</Typography>
                    </Grid>}
                    {showError && <Grid item>
                        <Typography sx={{ color: globals.colors.darkRed, fontWeight: 'bold' }}>{isAdminMode && errorMessage ? errorMessage : 'Възникна грешка при запазване на срещата!'}</Typography>
                    </Grid>}


                    {!isAdminMode && <Grid container sx={{ mt: 8 }} direction={'column'}>
                        <Typography sx={{ fontSize: 25, color: globals.colors.darkBlue, fontWeight: 'bold', mb: 2 }}>Предстоящи Zoom срещи</Typography>
                        <Paper>
                            {upcomingMeetings.map((meeting) => (
                                <Grid item key={meeting.id} sx={{ mt: 2, mx: 2, mb: 2 }}>
                                    <Typography sx={{ color: globals.colors.darkBlue, fontWeight: 'bold' }}>{meeting.topic} / {new Date(meeting.from_time).toLocaleDateString('bg-BG')} / {new Date(meeting.from_time).toLocaleTimeString('bg-BG')} ч.</Typography>
                                    <Button variant='contained' href='/meeting' type='submit' size='large' sx={{
                                        mt: 4, px: 5, backgroundColor: globals.colors.lightRed, textTransform: 'none', '&:hover': {
                                            backgroundColor: globals.colors.darkRed
                                        }, fontWeight: 'bold', mb: 2
                                    }}>Към срещата</Button>
                                    <IconButton sx={{ mt: 2, color: globals.colors.textColor }}><DeleteIcon /></IconButton>
                                    <Divider />
                                </Grid>
                            ))}
                        </Paper>
                    </Grid>}
                </Container >
            )}
        </>
    );
}

export default ZoomPage
